import { Component, computed, inject } from '@angular/core';
import { environment } from '../environments/environment';
import { IonicModule } from '@ionic/angular';
import { EnvironmentBannerComponent } from '@libs/ui/environment-banner';
import { NetworkService } from '@libs/core/network';

@Component({
  selector: 'pt-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
  imports: [IonicModule, EnvironmentBannerComponent],
})
export class AppComponent {
  environment = environment.appEnvironment;
  networkService = inject(NetworkService);

  isOnline = computed(() => this.networkService.isOnline());
}
